module.exports = __webpack_public_path__ + "img/0130.caf02a1c.png";